import React, { useMemo } from "react";

const Receipt = React.forwardRef(({ order }, ref) => {
  if (!order) return null;

  // Group items by garmentType and calculate quantity and total for each type
  const garmentSummary = useMemo(() => {
    const summary = {};
    order.items.forEach((item) => {
      const price = Number(item.sellingPrice) || 0;
      if (!summary[item.garmentType]) {
        summary[item.garmentType] = {
          garmentType: item.garmentType,
          quantity: 0,
          totalPrice: 0
        };
      }
      summary[item.garmentType].quantity += 1;
      summary[item.garmentType].totalPrice += price;
    });
    return Object.values(summary);
  }, [order.items]);

  return (
    <div
      ref={ref}
      style={{
        width: "340px",
        border: "1px solid #000",
        fontFamily: "Arial",
        fontSize: "12px",
        margin: "auto",
        background: "#fff"
      }}
    >
      {/* Header */}
      <div style={{ textAlign: "center", padding: "8px" }}>
        <h3 style={{ margin: 0 }}>RCITMS TAILORING SYSTEM</h3>
        <p style={{ margin: 0, fontSize: "11px" }}>
          Professional Tailor Management
        </p>
      </div>

      {/* Title */}
      <div
        style={{
          background: "#1f6b52",
          color: "#fff",
          textAlign: "center",
          padding: "6px",
          fontWeight: "bold"
        }}
      >
        Order Receipt
      </div>

      {/* Customer Details */}
      <div style={{ padding: "8px" }}>
        <p><b>Name:</b> {order.customer?.name}</p>
        <p><b>Contact:</b> {order.customer?.phone}</p>

        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <span><b>Order No:</b> {order.orderNumber}</span>
          <span><b>Date:</b> {new Date(order.createdAt).toLocaleString()}</span>
        </div>
      </div>

      {/* Items Summary - Grouped by Garment Type */}
      <div style={{ borderTop: "1px solid #000", padding: "8px" }}>
        <div style={{ fontWeight: "bold", marginBottom: "6px" }}>
          Items Summary:
        </div>

        <table style={{ width: "100%", borderCollapse: "collapse", fontSize: "14px" }}>
          <thead>
            <tr>
              <th style={{ border: "1px solid #000", padding: "4px" }}>Garment</th>
              <th style={{ border: "1px solid #000", padding: "4px" }}>Qty</th>
              <th style={{ border: "1px solid #000", padding: "4px" }}>Price</th>
            </tr>
          </thead>

          <tbody>
            {garmentSummary.map((item, index) => (
              <tr key={index}>
                <td style={{ border: "1px solid #000", padding: "4px" }}>
                  {item.garmentType}
                </td>
                <td style={{ border: "1px solid #000", padding: "4px", textAlign: "center" }}>
                  {item.quantity}
                </td>
                <td style={{ border: "1px solid #000", padding: "4px", textAlign: "right" }}>
                  ₹{Number(item.totalPrice).toString()}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Total */}
      <div
        style={{
          borderTop: "1px solid #000",
          padding: "8px",
          fontWeight: "bold",
          display: "flex",
          justifyContent: "space-between"
        }}
      >
        <span>Total</span>
        <span>₹{order.totalSellingPrice}</span>
      </div>

      {/* Due Date */}
      <div style={{ padding: "8px" }}>
        <p><b>Delivery Date:</b> {order.dueDate}</p>
      </div>

      {/* Footer */}
      <div
        style={{
          background: "#1f6b52",
          color: "#fff",
          textAlign: "center",
          padding: "6px",
          fontSize: "11px"
        }}
      >
        Thank you for choosing our tailoring service
      </div>
    </div>
  );
});

export default Receipt;